import type { ControllerSession } from '../controller.js';
import { fmtTime } from './common.js';

export function ReviewView({ session }: { session: ControllerSession }) {
  const rec = session.engine?.record;
  if (!rec) return <p className="muted">No event loaded.</p>;
  const url = session.exportUrl();
  const download = () => {
    const blob = new Blob([JSON.stringify(rec, null, 2)], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `${rec.eventId}-record.json`;
    a.click();
  };
  return (
    <div>
      <h2>Rounds</h2>
      <table>
        <thead>
          <tr>
            <th>Round</th>
            <th>Opened</th>
            <th>Closed</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(rec.roundTimes).map(([id, t]) => (
            <tr key={id}>
              <td>{id}</td>
              <td>{fmtTime(t.openedAt)}</td>
              <td>{fmtTime(t.closedAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2>Transitions</h2>
      <table>
        <thead>
          <tr>
            <th>Id</th>
            <th>Target</th>
            <th>Started</th>
            <th>Written</th>
            <th>Failed</th>
            <th>Mismatched</th>
            <th>Exceptions accepted</th>
          </tr>
        </thead>
        <tbody>
          {rec.transitions.map((t) => (
            <tr key={t.transitionId}>
              <td>{t.transitionId.slice(0, 8)}</td>
              <td>{t.targetRoundId ?? 'end'}</td>
              <td>{fmtTime(t.startedAt)}</td>
              <td>{t.written.length}</td>
              <td>{t.failed.length}</td>
              <td>{t.mismatched.length}</td>
              <td>{t.acceptedExceptions ? 'yes' : 'no'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2>Overrides</h2>
      <ul>
        {rec.overrides.map((o, i) => (
          <li key={i}>
            {o.participantId}: {o.action.kind}
            {o.action.kind === 'redirect' ? ` to ${o.action.destinationRoomId}` : ''} · {o.scope} from {o.fromRoundId} · {fmtTime(o.createdAt)}
          </li>
        ))}
      </ul>

      <h2>Manual observations</h2>
      <ul>
        {rec.manualObservations.map((o, i) => (
          <li key={i}>
            {fmtTime(o.at)} {o.participantId} seen in {o.roomId} by {o.by}
            {o.note ? ` (${o.note})` : ''}
          </li>
        ))}
      </ul>

      <h2>Audit log</h2>
      <table>
        <thead>
          <tr>
            <th>Time</th>
            <th>Actor</th>
            <th>Schedule</th>
            <th>Action</th>
            <th>Result</th>
            <th>Detail</th>
          </tr>
        </thead>
        <tbody>
          {rec.audit.slice(-200).map((a, i) => (
            <tr key={i}>
              <td>{fmtTime(a.at)}</td>
              <td>{a.actor}</td>
              <td>{a.scheduleVersion ?? ''}</td>
              <td>{a.action}</td>
              <td>{a.result}</td>
              <td>{a.detail ?? ''}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2>Export</h2>
      <p className="muted">present and absent describe the main-session checkpoint; listed means the platform listing showed the assignment. Nothing is a confirmation of attendance in a room unless recorded as a manual observation.</p>
      <div className="row">
        {url && (
          <>
            <a href={url}>Download JSON export</a>
            <a href={`${url}?format=csv`}>Download outcomes CSV</a>
          </>
        )}
        {session.canExport ? (
          <button className="secondary" onClick={download}>
            Download raw record
          </button>
        ) : (
          <span className="muted">Exports are available to the organiser in the admin console.</span>
        )}
      </div>
    </div>
  );
}
